import React from 'react'

export default function IndustryInvest({ data }) {
  return (
    <>
      <section className="industry-invest-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <h3 className="heading center-heading">{data?.head}</h3>
            </div>
            {data?.boxes?.map((item, ind) => (
              <div key={ind} className="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp" data-wow-duration="0.8s" data-wow-delay={`0.${ind+2}s`}>
                <div className="industry-invest-box">
                  <img src={item?.img} alt="Main" />
                  <img src={item?.icon} alt="Icon" />
                  <span>{item?.title}</span>
                  <p>{item?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
